
import { useCallback, useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import ImageUploaderModal from "./ImageUploaderModal";
import ImageGrid from "./ImageGrid";
import "./imageDashboard.scss";

const ImageDashboard = ({
    title,
    api,
    fetchEndpoint,
    uploadEndpoint,
    reorderEndpoint,
    renameEndpoint,
    deleteEndpointBase,
    allowReorder
}) => {
    const axiosPrivate = useAxiosPrivate();
    const [images, setImages] = useState([]); // array of {filename, url}
    const [uploaderOpen, setUploaderOpen] = useState(false);

    const fetchImages = useCallback(async () => {
        try {
            const res = await axiosPrivate.get(fetchEndpoint);
            setImages(res.data);
        } catch (err) {
            console.error("Fetch images failed", err);
        }
    }, [axiosPrivate, fetchEndpoint]);

    useEffect(() => { fetchImages(); }, [fetchImages]);

    const handleDelete = async (filename) => {
        try {
            await axiosPrivate.delete(`${deleteEndpointBase}/${filename}`);
            setImages(prev => prev.filter(i => i.filename !== filename));
            fetchImages();
        } catch (err) {
            console.error("Delete failed", err);
        }
    };

    const handleRenameSuccess = (oldName, newObj) => {
        
        setImages(prev => prev.map(i => i.filename === oldName ? newObj : i));
    };

    const handleClientReorder = (newFilenames) => {
        // create new ordered image objects by filename
        const map = Object.fromEntries(images.map(i => [i.filename, i]));
        const ordered = newFilenames.map(fn => map[fn]).filter(Boolean);
        // append any missing images at end
        const remaining = images.filter(i => !newFilenames.includes(i.filename));
        setImages([...ordered, ...remaining]);
    };

    return (
        <div className="imageDashboard">
            <div className="dashboardHeader">
                <h2>{title}</h2>
                <div className="actions">
                    <button className="primary" onClick={() => setUploaderOpen(true)}>Upload Images</button>
                    <button className="refreshBtn" onClick={fetchImages}>Refresh</button>
                </div>
            </div>

            <ImageGrid
                images={images}
                baseURL={process.env.REACT_APP_API_URL}
                api={api}
                allowReorder={allowReorder}
                reorderEndpoint={reorderEndpoint}
                renameEndpoint={renameEndpoint}
                deleteHandler={handleDelete}
                onRenameSuccess={handleRenameSuccess}
                onClientReorder={handleClientReorder}
                refreshImages={fetchImages}
            />

            <ImageUploaderModal
                open={uploaderOpen}
                onClose={() => setUploaderOpen(false)}
                uploadEndpoint={uploadEndpoint}
                onUploaded={() => { setUploaderOpen(false); fetchImages(); }}
            />
        </div>
    );
};

export default ImageDashboard;
